<template>
    <div>
        <card-title-component :title="localName"></card-title-component>
        <div class="card-content">
            <div class="row">
                <div class="col">
                    <b-form-group id="name-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.name')"
                                  label-for="name-input">
                        <b-form-input id="name-input"
                                      class="o-form"
                                      type="text"
                                      v-model="localName"
                                      required
                                      :placeholder="$t('pets.pet.name')">
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="species-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.species')"
                                  label-for="species-input">
                        <b-form-input id="species-input"
                                      class="o-form"
                                      type="text"
                                      v-model="localSpecies"
                                      required
                                      :placeholder="$t('pets.pet.species')">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="birthdate-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.birthdate')"
                                  label-for="birthdate-input">
                        <datepicker v-model="localBirthdate" id="birthdate-input" class="o-form" :format="'dd.MM.yyyy'" :language="this.getLanguage()"></datepicker>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="transponder-id-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.transponderId')"
                                  label-for="transponder-id-input">
                        <b-form-input id="transponder-id-input"
                                      class="o-form"
                                      type="text"
                                      v-model="localTransponderId"
                                      required
                                      :placeholder="$t('pets.pet.transponderId')">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="veterinarian-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.veterinarian')"
                                  label-for="veterinarian-input">
                        <b-form-input id="veterinarian-input"
                                      class="o-form"
                                      type="text"
                                      v-model="localVeterinarian"
                                      required
                                      :placeholder="$t('pets.pet.addressPlaceholder')">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="custody-after-death-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.custody')"
                                  label-for="custody-after-death-input">
                        <b-form-input id="custody-after-death-input"
                                      class="o-form"
                                      type="text"
                                      v-model="localCustodyAfterDeath"
                                      required
                                      :placeholder="$t('pets.pet.addressPlaceholder')">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="notes-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.notes')"
                                  label-for="notes-input">
                        <b-form-textarea id="notes-input"
                                         class="o-form"
                                         type="text"
                                         v-model="localNotes"
                                         :rows="5"
                                         :max-rows="10"
                                         :placeholder="$t('pets.pet.notes')">
                        </b-form-textarea>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col button-div">
                    <b-button class="delete-button o-button" v-on:click="deletePet(petId)">
                        {{$t('pets.deleteButton')}}
                    </b-button>
                    <b-button class="save-button o-button" v-on:click="savePet">
                        {{$t('pets.saveButton')}}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import {
        PETS_GETTER_PET_BY_ID,
        PETS_MUTATION_SINGLE_PET_ATTRIBUTE,
        PETS_ACTION_UPDATE_PET,
        PETS_ACTION_DELETE_PET,
        PETS_NAMESPACE
    } from '../../store/modules/pets-types'
    import Datepicker from 'vuejs-datepicker'
    import {de, en} from 'vuejs-datepicker/dist/locale'

    export default {
        name: 'Pet',
        components: {
            'card-title-component': CardTitleComponent,
            'datepicker': Datepicker
        },
        props: ['petId', 'firstname', 'lastname'],
        computed: {
            ...mapGetters(PETS_NAMESPACE, {
                pet: PETS_GETTER_PET_BY_ID
            }),
            localPet: {
                get () { return this.pet(this.petId) },
                set (value) { this.updatePetSingleAttribute({payload: this.localPet}) }
            },
            localName: {
                get () { return this.localPet.name },
                set (value) { this.updatePetSingleAttribute({id: this.petId, name: value}) }
            },
            localBirthdate: {
                get () { return this.localPet.birthdate },
                set (value) { this.updatePetSingleAttribute({id: this.petId, birthdate: value.toISOString()}) }
            },
            localSpecies: {
                get () { return this.localPet.species },
                set (value) { this.updatePetSingleAttribute({id: this.petId, species: value}) }
            },
            localTransponderId: {
                get () { return this.localPet.transponderId },
                set (value) { this.updatePetSingleAttribute({id: this.petId, transponderId: value}) }
            },
            localVeterinarian: {
                get () { return this.localPet.veterinarian },
                set (value) { this.updatePetSingleAttribute({id: this.petId, veterinarian: value}) }
            },
            localCustodyAfterDeath: {
                get () { return this.localPet.custodyAfterDeath },
                set (value) { this.updatePetSingleAttribute({id: this.petId, custodyAfterDeath: value}) }
            },
            localNotes: {
                get () { return this.localPet.notes },
                set (value) { this.updatePetSingleAttribute({id: this.petId, notes: value}) }
            }
        },
        methods: {
            ...mapMutations(PETS_NAMESPACE, {
                updatePetSingleAttribute: PETS_MUTATION_SINGLE_PET_ATTRIBUTE
            }),
            ...mapActions(PETS_NAMESPACE, {
                deletePet: PETS_ACTION_DELETE_PET,
                updatePet: PETS_ACTION_UPDATE_PET
            }),
            savePet () {
                this.updatePet(this.localPet)
            },
            getLanguage () {
                if (this.$i18n.locale === 'en') {
                    return en
                } else {
                    return de
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/pets/PetComponent.vue